import { AxiosResponse } from 'axios';
import { USERS_API_URL } from '../../../../config';
import { ISample } from '../../../../interfaces/sample/ISample';
import { PaginatedSample } from '../../../../interfaces/sample/paginatedStore.type';

import brokersAxios from '../../../../utils/axios/brokers-roles.axios';

const tryToFetchSamples = (
    pageNumber: number,
    pageSize: number,
    filters?: string,
): Promise<AxiosResponse<PaginatedSample>> => {
    const url = `${USERS_API_URL}/samples/all?page=${pageNumber}&size=${pageSize}`
    return brokersAxios.get<PaginatedSample>(url);
};

const tryToAddSample = (data: ISample): Promise<AxiosResponse> => {
    return brokersAxios.post(`${USERS_API_URL}/sample`, data);
};

const tryToFetchSingleSample = (sampleId: string): Promise<AxiosResponse> => {
    return brokersAxios.put(`${USERS_API_URL}/samples/${sampleId}`);
};

const tryToEditSample = (sampleId: string, payload: ISample): Promise<AxiosResponse> => {
    return brokersAxios.put(`${USERS_API_URL}/sample/${sampleId}`, payload);
};

export const SamplesService = {
    tryToFetchSamples,
    tryToFetchSingleSample,
    tryToAddSample,
    tryToEditSample
};
